import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderService } from '../../../service/order.service';
import { InvoiceService } from '../../../service/invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../../shared/AppSettings';
import { ThrowStmt } from '@angular/compiler';
import { InvoiceFilePreviewComponent } from '../../invoice-file-preview/invoice-file-preview.component';

@Component({
    selector: 'app-supplier-invoice-details',
    templateUrl: './supplier-invoice-details.component.html',
    styleUrls: ['./supplier-invoice-details.component.css']
})
export class SupplierInvoiceDetailsComponent implements OnInit {

  @ViewChild(InvoiceFilePreviewComponent)  filePreview: InvoiceFilePreviewComponent;

  readonly rootUrl = AppSettings.webApiURL;
  
  invoiceDetails: any;
  orderIdLink: any = null;
  orderId?: number = null;
  showInvoicePreviewDialog: boolean = false;

  // showConfirmDialog: boolean = false;
  // showRejectDialog: boolean = false;
  // showRedirectDialog: boolean = false;

  // nextConfirmerSeleted: any;
  // nextConfirmerNotes: any;

  colsSigns = [
      { field: 'Step', header: 'סידורי', width: '80', priority: 'ui-p-6' },
      { field: 'SignUserFullName', header: 'חותם', width: '120', priority: 'ui-p-1'   },
      { field: 'Decision', header: 'החלטה', width: '50', priority: 'ui-p-1'  },
      { field: 'SignDate', header: 'תאריך', width: '80', priority: 'ui-p-2'  },
      { field: 'ForwarderToUserFullName', header: 'הועבר אל', width: '120', priority: 'ui-p-6'   },
      { field: 'Notes', header: 'הערות', width: '200', priority: 'ui-p-6'   }
  ];
  decisionClass = [
    'decision-empty',
    'decision-confirm',
    'decision-reject',
    'decision-redirectTreatment'
  ];

  validationMessage: any;
  validationMessages: any[];
  msgs: Message[] = [];


  constructor(private orderService: OrderService, private invoiceService: InvoiceService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getInvoiceDetails();

    
  }

  orderDetailsCreated(event) {
    //
  }

  getInvoiceDetails()
  {
    //let invoiceId = this.route.snapshot.paramMap.get('invoice');
    //if (invoiceId == 'none') { invoiceId = null; }
    //if (invoiceId == null || invoiceId == '') {
      let invoiceId = this.route.snapshot.queryParamMap.get('o');
    //}
    let invoiceFilterByInvoiceIdEncoded = {
      //InvoiceId: invoiceId,
      InvoiceIdLink: invoiceId    };
    this.invoiceService.getSupplierInvoiceDetails(invoiceFilterByInvoiceIdEncoded).subscribe((result: any) => {
      this.invoiceDetails = result;
      if (this.invoiceDetails) {
        this.orderId = this.invoiceDetails.OrderId;
      }

    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.showMessage('error', '', errMessage);
      });
  }

  showFile() {
    this.showInvoicePreviewDialog = true;
    //this.filePreview.getInvoiceFile();
  }


  
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/invoice/supplier-invoice/supplier-invoice-details/supplier-invoice-details.component.ts